// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function Loading(Props) {
  return React.createElement("div", {
              className: "loading"
            }, React.createElement("div", {
                  className: "spinner spinner--rec-circle"
                }));
}

var make = Loading;

export {
  make ,
  
}
/* react Not a pure module */
